module.exports = __webpack_public_path__ + "static/shared/img/icons/iconAllyDownload-IC-Black.edde979ad5266d2085fee7571f1af90f.svg";